export default "__VITE_ASSET__D3tgRuG5__"